import { Permission } from '../../../../core/enums/permission.enum';
import { PaletteCommand } from '../command-palette/command-palette.model';

/** Who sees the Configurations entry (header button and command palette). */
export const CONFIGURATION_PERMISSIONS = [
  Permission.CONFIG_STAFFING,
  Permission.CONFIG_BSA,
  Permission.CONFIG_INVOICING,
  Permission.CONFIG_PERFORMANCE,
  Permission.CONFIG_USER_MANAGEMENT,
  Permission.MANAGER_READ,
  Permission.MANAGER_WRITE,
  Permission.MANAGER_PEOPLE,
  Permission.DIRECTOR_READ,
  Permission.DIRECTOR_WRITE,
];

export interface HeaderCommandContext {
  isDarkMode: boolean;
  currentLanguage: string | undefined;
  languages: { code: string; label: string }[];
  canOpenConfigurations: boolean;
  setDarkMode(dark: boolean): void;
  setLanguage(code: string): void;
  openConfigurations(): void;
  changePassword(): void;
  logout(): void;
}

/** The header's actions, offered in the command palette. */
export function headerCommands(context: HeaderCommandContext): PaletteCommand[] {
  const commands: PaletteCommand[] = [
    {
      id: 'preferences:theme',
      group: 'preferences',
      title: context.isDarkMode ? 'commandPalette.commands.lightTheme' : 'commandPalette.commands.darkTheme',
      icon: context.isDarkMode ? 'pi pi-sun' : 'pi pi-moon',
      keywords: ['theme', 'dark', 'light', 'mode'],
      run: () => context.setDarkMode(!context.isDarkMode),
    },
    ...context.languages.map((language): PaletteCommand => ({
      id: `preferences:language:${language.code}`,
      group: 'preferences',
      title: language.label,
      literalTitle: true,
      hint: ['layout.header.language'],
      icon: 'pi pi-language',
      keywords: ['language', 'langue', 'idioma', language.code],
      current: language.code === context.currentLanguage,
      run: () => context.setLanguage(language.code),
    })),
  ];

  if (context.canOpenConfigurations) {
    commands.push({
      id: 'account:configurations',
      group: 'account',
      title: 'layout.header.configurations',
      icon: 'pi pi-cog',
      keywords: ['settings', 'configuration'],
      run: () => context.openConfigurations(),
    });
  }

  commands.push(
    {
      id: 'account:password',
      group: 'account',
      title: 'layout.header.updatePassword',
      icon: 'pi pi-lock',
      keywords: ['password', 'security'],
      run: () => context.changePassword(),
    },
    {
      id: 'account:logout',
      group: 'account',
      title: 'layout.header.logout',
      icon: 'pi pi-sign-out',
      keywords: ['logout', 'sign out', 'disconnect'],
      run: () => context.logout(),
    },
  );
  return commands;
}
